import { useState, useEffect } from "react";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import MDBox from "../../../components/MDBox";
import MDModal from "../../../components/MDModal";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";

import { putRef, postRef, getRef, deleteRef } from "../../../api/refs";
import { getModels } from "../../../api/models";

import RefInfos from "./RefInfos";

import PropTypes from "prop-types";

import { useSelector, useDispatch } from "react-redux";

import { setAllSuppliers } from "../../../redux/reducers/suppliersReducer";

import { getSuppliers } from "../../../api/suppliers";

import { deviceType } from "../../../config/enum";

export default function CreateEditRefs({ edit = false, refs, setRefs, device }) {
  const [open, setOpen] = useState(false);

  const [step, setStep] = useState(0);
  const steps = edit ? refs.map((_, i) => `fournisseur ${i + 1}`) : ["situation 1"];
  const isLastStep = step === steps.length - 1;
  const isFirstStep = step === 0;

  const [refId, setRefId] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [model, setModel] = useState(null);
  const [models, setModels] = useState([]);
  const [supplierRef, setSupplierRef] = useState("");
  const [allGood, setAllGood] = useState(false);

  async function fetchRefs() {
    const response = await getRef(device.device_id);
    setRefs(response.data);
  }

  useEffect(() => {
    fetchRefs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchThings() {
    const suppliersResponse = await getSuppliers({ [`tblsupplier.${deviceType[device.type]}`]: 1 });
    const formatedSuppliers = await suppliersResponse.data.map((supplier) => ({
      label: supplier.supplier_name,
      id: supplier.supplier_id,
    }));
    setSuppliers(formatedSuppliers);
    setAllGood(true);
  }

  useEffect(() => {
    fetchThings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (edit && refs && refs[step] !== undefined && allGood) {
      setRefId(refs[step].ref_id);
      setSupplier(
        suppliers.length > 0 && suppliers.find((supplier) => supplier.id === refs[step].supplier_id)
      );
      setSupplierRef(refs[step].ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, refs, allGood]);

  async function createRefAPI() {
    const ref = {
      device_id: device.device_id,
      supplier_id: supplier ? supplier.id : null,
      model_id: model ? model.id : null,
      ref: supplierRef,
    };
    await postRef(ref);
  }

  async function deleteRefAPI() {
    await deleteRef(refId);
  }

  async function updateRefAPI() {
    const ref = {
      supplier_id: supplier ? supplier.id : null,
      model_id: model ? model.id : null,
      ref: supplierRef,
    };
    await putRef(ref, refId);
  }

  function resetData() {
    setModel(null);
    setSupplier(null);
    setSupplierRef("");
  }

  async function deleteBill() {
    await deleteRefAPI();
    await fetchRefs();
    exit();
  }

  async function cancel() {
    if (edit) {
      await fetchRefs();
    } else {
      resetData();
    }
    exit();
  }

  async function submit() {
    if (edit) {
      await updateRefAPI();
      await fetchRefs();
    } else {
      await createRefAPI();
      await fetchRefs();
      resetData();
      exit();
    }
  }

  function exit() {
    setStep(0);
    setOpen(false);
  }

  const next = () => {
    setStep(step + 1);
  };

  const previous = () => setStep(step - 1);

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <>
      {edit ? (
        <IconButton size="medium" disableRipple color="inherit" onClick={() => setOpen(true)}>
          <Icon style={{ color: darkMode ? "#344767" : "#FFF" }}>edit</Icon>
        </IconButton>
      ) : (
        <IconButton size="medium" disableRipple color="inherit" onClick={() => setOpen(true)}>
          <Icon style={{ color: darkMode ? "#344767" : "#FFF" }}>add</Icon>
        </IconButton>
      )}
      <MDModal open={open} onClose={() => setOpen(false)}>
        <MDBox mt={25} mb={9}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <Card>
                <MDBox
                  mt={edit ? -12 : -5}
                  mb={2}
                  mx={2}
                  variant="gradient"
                  sx={{
                    background: darkMode ? "white" : "linear-gradient(195deg, #364c70, #273956)",
                    boxShadow: darkMode ? "0 1px 6px 1px white" : "0 1px 6px 1px #344767",
                  }}
                  borderRadius="lg"
                  textAlign="center"
                >
                  <MDBox mt={2} mb={edit ? 1 : 2}>
                    <MDBox>
                      {edit ? (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Modification des fournisseurs
                        </MDTypography>
                      ) : (
                        <MDTypography
                          variant="h3"
                          fontWeight="bold"
                          color={darkMode ? "inherit" : "white"}
                        >
                          Ajouter un nouveau fournisseur
                        </MDTypography>
                      )}
                    </MDBox>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      color={darkMode ? "inherit" : "white"}
                    >
                      Veuillez rentrer les informations relatives au fournisseur
                    </MDTypography>
                  </MDBox>
                  {edit && (
                    <Stepper
                      sx={{ boxShadow: "none", backgroundImage: "none" }}
                      activeStep={step}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step
                          sx={{
                            "& .MuiStepConnector-root.MuiStepConnector-horizontal.MuiStepConnector-alternativeLabel.Mui-active":
                              {
                                color: darkMode && "#344767 !important",
                              },
                            "& .MuiStepConnector-root.MuiStepConnector-horizontal.MuiStepConnector-alternativeLabel.Mui-completed":
                              {
                                color: darkMode && "#344767 !important",
                              },
                          }}
                          key={label}
                        >
                          <StepLabel
                            sx={{
                              "& .MuiStepLabel-label.Mui-active": {
                                color: darkMode && "#344767 !important",
                              },
                              "& .MuiStepLabel-label.Mui-completed": {
                                color: darkMode && "#344767 !important",
                              },
                              "& .MuiStepIcon-root.Mui-active": {
                                background: darkMode && "#344767",
                                fill: darkMode && "#344767",
                                stroke: darkMode && "#344767",
                                borderColor: darkMode && "#344767",
                                boxShadow: darkMode && "0rem 0rem 0rem 0.125rem #344767",
                              },
                              "& .MuiStepIcon-root.Mui-completed": {
                                background: darkMode && "#344767",
                                fill: darkMode && "#344767",
                                stroke: darkMode && "#344767",
                                borderColor: darkMode && "#344767",
                                boxShadow: darkMode && "0rem 0rem 0rem 0.125rem #344767",
                              },
                            }}
                          >
                            {label}
                          </StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  )}
                </MDBox>
                <MDBox p={2}>
                  <MDBox>
                    <RefInfos
                      edit={edit}
                      refs={refs}
                      step={step}
                      supplier={supplier}
                      setSupplier={setSupplier}
                      suppliers={suppliers}
                      model={model}
                      setModel={setModel}
                      models={models}
                      setModels={setModels}
                      supplierRef={supplierRef}
                      setSupplierRef={setSupplierRef}
                    />
                    <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                      <MDBox width="50%">
                        {isFirstStep ? (
                          <MDBox />
                        ) : (
                          <MDButton variant="gradient" color="warning" onClick={previous}>
                            Précédent
                          </MDButton>
                        )}
                      </MDBox>
                      <MDBox textAlign="right" width="50%">
                        <Grid container justifyContent="right" spacing={1.5}>
                          {isLastStep && steps.length > 0 ? (
                            <MDBox />
                          ) : (
                            <Grid item>
                              <MDButton variant="gradient" color="info" onClick={next}>
                                Suivant
                              </MDButton>
                            </Grid>
                          )}
                          <Grid item>
                            <MDButton variant="gradient" color="warning" onClick={cancel}>
                              Annuler
                            </MDButton>
                          </Grid>
                          <Grid item>
                            <MDButton variant="gradient" color="success" onClick={submit}>
                              Envoyer
                            </MDButton>
                          </Grid>
                          {edit && (
                            <Grid item>
                              <MDButton variant="gradient" color="error" onClick={deleteBill}>
                                Supprimer
                              </MDButton>
                            </Grid>
                          )}
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDModal>
    </>
  );
}

CreateEditRefs.propTypes = {
  edit: PropTypes.bool.isRequired,
};
